























































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component
export default class OutputCsvDialog extends Vue {
  /** ボタンレイアウト属性 */
  @Prop()
  private readonly reportButtonAttrs!: object;

  /** ボタンの無効状態 */
  @Prop()
  private readonly disabled!: boolean;

  /** CSV出力を実行 */
  @Emit("execOutputCsv")
  private execOutputCsv() {
    this.isOpenDialog1 = false;
    this.isOpenDialog2 = false;
    return;
  }

  /** ダイアログ開閉状態1 */
  private isOpenDialog1 = false;

  /** ダイアログ開閉状態2 */
  private isOpenDialog2 = false;

  /** ダイアログを閉じる */
  private hideOutputCsvDialog() {
    this.isOpenDialog1 = false;
    this.isOpenDialog2 = false;
  }
}
